/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown> }} Admin_Shared_Time_Ago_In_DaysInputs */

const en_admin_shared_time_ago_in_days = /** @type {(inputs: Admin_Shared_Time_Ago_In_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days}d ago`)
};

const de_admin_shared_time_ago_in_days = /** @type {(inputs: Admin_Shared_Time_Ago_In_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`vor ${i?.days} Tagen`)
};

const es_admin_shared_time_ago_in_days = /** @type {(inputs: Admin_Shared_Time_Ago_In_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`hace ${i?.days}d`)
};

const fr_admin_shared_time_ago_in_days = /** @type {(inputs: Admin_Shared_Time_Ago_In_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`il y a ${i?.days}j`)
};

const it_admin_shared_time_ago_in_days = /** @type {(inputs: Admin_Shared_Time_Ago_In_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days}g fa`)
};

const pt_br2_admin_shared_time_ago_in_days = /** @type {(inputs: Admin_Shared_Time_Ago_In_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`há ${i?.days}d`)
};

const pl_admin_shared_time_ago_in_days = /** @type {(inputs: Admin_Shared_Time_Ago_In_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days}d temu`)
};

const hu_admin_shared_time_ago_in_days = /** @type {(inputs: Admin_Shared_Time_Ago_In_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} napja`)
};

const ro_admin_shared_time_ago_in_days = /** @type {(inputs: Admin_Shared_Time_Ago_In_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`acum ${i?.days}z`)
};

/**
* | output |
* | --- |
* | "{days}d ago" |
*
* @param {Admin_Shared_Time_Ago_In_DaysInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_shared_time_ago_in_days = /** @type {((inputs: Admin_Shared_Time_Ago_In_DaysInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Shared_Time_Ago_In_DaysInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_shared_time_ago_in_days(inputs)
	if (locale === "de") return de_admin_shared_time_ago_in_days(inputs)
	if (locale === "es") return es_admin_shared_time_ago_in_days(inputs)
	if (locale === "fr") return fr_admin_shared_time_ago_in_days(inputs)
	if (locale === "it") return it_admin_shared_time_ago_in_days(inputs)
	if (locale === "pt-BR") return pt_br2_admin_shared_time_ago_in_days(inputs)
	if (locale === "pl") return pl_admin_shared_time_ago_in_days(inputs)
	if (locale === "hu") return hu_admin_shared_time_ago_in_days(inputs)
	return ro_admin_shared_time_ago_in_days(inputs)
});
export { admin_shared_time_ago_in_days as "admin.shared.time_ago_in_days" }